import React, { useMemo, useCallback } from 'react';
import { Steps } from '@packages/ui/patterns/Steps';
import type { Step } from '@packages/ui/patterns/Steps';
import type { StepProcessorReturn } from '../processors/stepProcessor';

interface FormWizardStepperProps {
  stepProcessor: StepProcessorReturn;
}

export const FormWizardStepper = React.memo(function FormWizardStepper({
  stepProcessor,
}: FormWizardStepperProps): React.ReactElement {
  const { visibleSteps, currentStepIndex } = stepProcessor;

  const steps: Step[] = useMemo(
    () => visibleSteps.map((s) => ({ label: s.label })),
    [visibleSteps]
  );

  const handleStepClick = useCallback(
    (index: number) => {
      if (index < currentStepIndex) {
        stepProcessor.goToStep(visibleSteps[index].id);
      }
    },
    [currentStepIndex, stepProcessor, visibleSteps]
  );

  return (
    <div style={{ marginBottom: '24px' }}>
      <Steps
        steps={steps}
        currentStep={currentStepIndex + 1}
        variant='compact'
        size='md'
        onStepClick={handleStepClick}
        semanticId='formWizardSteps'
      />
    </div>
  );
});
